export const productShortName = 'Power Distribution & Switchgear — Professional Edition™';
export const productBrand = 'Power Distribution & Switchgear';
export const productEdition = 'Professional Edition™';
export const productImage = 'https://cdn.magicpatterns.com/uploads/ambq98phzE1eWiu37D7rjQ/MOCKUP_SWITCHGEAR.png';
export const productImageAlt =
  'Power Distribution & Switchgear Professional Edition: six volumes covering distribution fundamentals, LV switchboards and MCCs, MV switchgear, circuit breakers and protection coordination, testing and maintenance, and electrical safety, plus five bonus resources';

export const checkoutUrl = 'https://power-distribution-switchgear.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusValue = 'USD 14.00';
export const bonusTotalValue = 'USD 70.00';

export const closingLines = [
  'No more confusion about how power flows from the supply point to the load',
  'No more uncertainty about why breakers trip and how protection is coordinated',
  'No more gaps in understanding LV switchboards and MV switchgear',
  'No more improvising testing, maintenance and safety procedures',
  'No more struggling to read single-line diagrams and panel drawings',
];
